import { forwardRef } from "react";
import InputField from "./InputField.js";

const TextField = forwardRef(function (props, ref) {
  return <InputField type="text" {...props} />;
});
TextField.displayName = "TextField";

export default TextField;
